<!-- 数字护照信息 -->
<!-- 参数 params id   query lang 当前语言  is_public 是否公开数据-->
<!-- ex: passport/676d0acac423446de03a84c3?lang=en-->
<!-- ex: passport/676d0acac423446de03a84c3?lang=ch-->
<script setup>
import { onBeforeMount, onMounted, provide, ref } from 'vue';
import { useRoute } from 'vue-router';
//  import { getFileUrl } from "@/service/index"
import { getLangValue, } from "@/utils/common"; //获取后端语言
import i18n from "@/i18n"
import homeCom from "./components/home.vue"
import radarInstandardCom from "./components/radarInstandard.vue"
const route = useRoute();
const activeMenu = ref(0)
provide('activeMenu', activeMenu)// 当前展开的菜单
const productInfo = ref({})
provide('productInfo', productInfo) // 产品信息
const refs = ref([]); // tab refs
const setLang = () => {
    // 设置语言
    const language = route.query.lang;
    sessionStorage.setItem("language", language);
    i18n.global.locale = language;
}

//默认菜单
const menuList = [
    {
        name: getLangValue('menu.home'),
        com: homeCom,
        key: 0,
    },
    {
        name: getLangValue('dashboard.quality.title'),
        com: radarInstandardCom,
        key: 'quality',
        category_id: 3,
    },
    {
        name: getLangValue('dashboard.environment.title'),
        com: radarInstandardCom,
        category_id: 5,
        key: 'environment',
    },
    {
        name: getLangValue('dashboard.esg.title'),
        com: radarInstandardCom,
        category_id: 6,
        key: 'esg',
    },
    {
        name: getLangValue('dashboard.circularity.title'),
        com: radarInstandardCom,
        category_id: 4,
        key: 'circularity',
    },
    {
        name: getLangValue('dashboard.comfort.title'),
        com: radarInstandardCom,
        category_id: 2,
        key: 'comfort',
    },
    {
        name: getLangValue('dashboard.traceability.title'),
        com: radarInstandardCom,
        category_id: 1,
        key: 'traceability',
    },
]

const setToken = async () => {
    // 路由获取的token存到缓存里面
    let data = {
        token: route.query.token,
        timestamp:route.query.timestamp,
    }
    sessionStorage.setItem("set_menu_list", JSON.stringify(data));
}

const addRefs = (i) => {
    // 注册ref
    return (el) => {
        refs.value[i] = el;
    };
}

onBeforeMount(()=> {
    setLang();
})

onMounted(async () => {
   
    await setToken();
    // 获取信息
    refs.value[0].getProductInfo();
})

</script>
<template>
    <div class="passwort d-flex flex-column bg-white">
        <div class="title my-3" style="max-height: 24px;">{{ getLangValue('dashboard', 'product_digital_passport') }}
        </div>
        <div class="passwort-menu px-2 pt-1 flex-1 overflow-auto">
            <!-- Nesting Accordions -->
            <div class="accordion nesting-accordion custom-accordionwithicon accordion-border-box"
                id="accordionnesting">
                <div class="accordion-item" v-for="(item, key) in menuList" :key="key">
                    <h2 class="accordion-header" :id="`accordionnestingExample` + key">
                        <button @click="activeMenu = key" class="accordion-button collapsed" type="button"
                            data-bs-toggle="collapse" :data-bs-target="`#accor_nestingExamplecollapse` + key"
                            aria-expanded="false" :aria-controls="`accor_nestingExamplecollapse` + key">
                            <i class="ri-home-4-line me-2"></i>{{ item.name }}
                        </button>
                    </h2>
                    <div :id="`accor_nestingExamplecollapse` + key" class="accordion-collapse collapse"
                        :aria-labelledby="`accordionnestingExample` + key" data-bs-parent="#accordionnesting">
                        <div class="accordion-body px-1 py-0">
                            <component :is="item.com" :activekey="key" :category_key="item.key"
                                :category_id="item.category_id" :ref="addRefs(key)" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
.passwort {
    height: 100Vh;
    overflow-y: auto;

    .title {
        color: #003A8C;
        font-size: 1rem;
        text-align: center;
        font-weight: bold;
    }

    .passwort-menu {
        border-top: 1px solid #0000001A;

        button {
            color: #003A8C;
            font-size: 1rem;

            i {
                font-size: 22px;
            }
        }
    }
}
</style>